import DateInput from "../../components/common/inputs/DateInput";

export default function AdminActivityFilter({ filterDataHandler }) {
  return (
    <div className="w-full flex flex-col flex-wrap my-8 gap-6 px-6">
      <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        <div className="w-full">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            نوع عملیات
          </label>
          <div className="relative">
            <select
              onChange={(e) =>
                filterDataHandler({ page: 1, action: e.target.value })
              }
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 pl-8 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 appearance-none"
            >
              <option value="">همه</option>
              <option value="create">ایجاد</option>
              <option value="update">ویرایش</option>
              <option value="delete">حذف</option>
              <option value="view">مشاهده</option>
              <option value="login">ورود</option>
              <option value="logout">خروج</option>
              <option value="export">خروجی</option>
            </select>
            <div className="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
              <svg
                className="w-4 h-4 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </div>
        </div>

        <div className="w-full">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            موجودیت
          </label>
          <div className="relative">
            <select
              onChange={(e) =>
                filterDataHandler({ page: 1, entity: e.target.value })
              }
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 pl-8 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 appearance-none"
            >
              <option value="">همه</option>
              <option value="User">کاربر</option>
              <option value="Product">محصول</option>
              <option value="Category">دسته‌بندی</option>
              <option value="Order">سفارش</option>
              <option value="Coupon">کوپن</option>
              <option value="Discount">تخفیف</option>
              <option value="Wallet">کیف پول</option>
              <option value="Article">مقاله</option>
              <option value="Slider">اسلایدر</option>
            </select>
            <div className="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
              <svg
                className="w-4 h-4 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </div>
        </div>

        <div className="w-full">
          <DateInput
            label={"از تاریخ"}
            onChange={(e) => filterDataHandler({ page: 1, from: e })}
          />
        </div>

        <div className="w-full">
          <DateInput
            label={"تا تاریخ"}
            onChange={(e) => filterDataHandler({ page: 1, to: e })}
          />
        </div>
      </div>
    </div>
  );
}
